import ContentPreChecker from './pre-checker';
import ContentAdder from './content-adder';
import { jsPDF } from 'jspdf';
import autoTable from 'jspdf-autotable';
import { Observable } from 'rxjs';

export default class PdfBuilder {
    readonly _DEBUG = false;
    
    readonly DOC_START_Y_CORD = 0;
    readonly DOC_START_X_CORD = 0;
    readonly SPACE_BETWEEN_CONTENT = 15;
  
    readonly CONTENT_MARGIN_LEFT = 30;

    attemptToAddContent = 0;

  /**
   * Todo: Remove infinite loop
   */
    
    doc:jsPDF;
    data:[];
  
    // Header and footer height
    hHeight:number;
    fHeight:number;
  
    // Track the available page space;
    occupiedPageSpace = 0;
    nextYCoord: number;
    constructor(){
      this.doc = new jsPDF('p', 'px', [595, 842]);
      this.doc.addFont("assets/trebuc.ttf", "TrebuchetMS", "normal");
      this.addHeaderAndFooter();
    }
    getContentOccupiableArea(){
      return this.getPDFHeight() - (this.hHeight + this.fHeight);
    }
  
    getPDFHeight(){
      return this.doc.internal.pageSize.getHeight();
    }

    getMargin() {
      return {
        top : this.hHeight + this.SPACE_BETWEEN_CONTENT,
        bottom: this.fHeight
      }
    }
    
    getContainerWidth() {
      /**
     * This can be overridable
     */
      return this.doc.internal.pageSize.getWidth() - (2 * this.CONTENT_MARGIN_LEFT);
    }
    getContainerStartWidth() {
      /**
       * Left to right
       */
      return this.CONTENT_MARGIN_LEFT;
    }

    getPDFWidth(){
      return this.doc.internal.pageSize.getWidth();
    }

    addHeader(){
      const BRAND_BANNER_HEIGHT = 45;
  
      const headerImageLogo = new Image()
      headerImageLogo.src = "assets/images/IQ_Platform_white_Logo.png"
      const imgHeaderHeight = 25;
      const imgHeaderWidth = imgHeaderHeight;
     
      this.doc.setFillColor(0, 171, 142);
      this.doc.rect(0, this.DOC_START_Y_CORD, this.getPDFWidth(), BRAND_BANNER_HEIGHT, 'F');
  
      const BRAND_TEXT_Y_COORD = this.DOC_START_Y_CORD + (BRAND_BANNER_HEIGHT - imgHeaderHeight)/2 ;
     
      
      
      this.doc.addImage(headerImageLogo, 30 , BRAND_TEXT_Y_COORD , imgHeaderWidth, imgHeaderHeight);
  
      
      this.hHeight = BRAND_BANNER_HEIGHT;
      // Fill next cord and occupied height
      this.nextYCoord = BRAND_BANNER_HEIGHT + this.SPACE_BETWEEN_CONTENT;
      this.occupiedPageSpace += this.SPACE_BETWEEN_CONTENT;
    }
    addFooter() {
      const pageHeight = this.getPDFHeight();
      const pageWidth = this.getPDFWidth();
      const footerLineHeight = 50
      const footerPosition = pageHeight-footerLineHeight;
      const footerTxtXPosition = pageWidth - 110;
      const footerTxtYPosition = pageHeight - (footerLineHeight / 1.5);
  
      // this.doc.setLineWidth(footerLineHeight);
      // this.doc.setDrawColor(0, 0, 0);
      // this.doc.line(0, footerPosition, pageWidth, footerPosition, 'FD');
      this.doc.setFillColor(0, 0, 0);
      this.doc.rect(0, footerPosition, pageWidth, footerLineHeight, 'F' )
      const imgFooterLogo = new Image()
      imgFooterLogo.src = "assets/images/KennedysIQ_white.png"
      const imgFooterHeight = 15;
      const imgFooterWidth = imgFooterHeight * 5.25;
      
      this.doc.addImage(imgFooterLogo, footerTxtXPosition, footerTxtYPosition, imgFooterWidth, imgFooterHeight);
      this.fHeight = footerLineHeight;
    }
    addHeaderAndFooter(){
      this.addHeader();
      this.addFooter();
    }
    addPage(){
      this.doc.addPage();
      this.addHeaderAndFooter();
      this.occupiedPageSpace = 0;
    }
    addData(data:[]){
      this.data = data;
    }
    getRemainingHeight() {
      return this.getContentOccupiableArea() - this.occupiedPageSpace;
    } 
    addContent(type:string, d:any):any{
      let x =  this.CONTENT_MARGIN_LEFT;
      let y =  this.nextYCoord + this.SPACE_BETWEEN_CONTENT;
      if(!ContentPreChecker[type]){
          throw Error("Content Pre checker not found for "+ type);
      }
      let {
        preCheckedWidth,
        preCheckedHeight,
        preCheckedX,
        preCheckedY
      } = ContentPreChecker[type].bind(this)(d, x, y);
      const remainingHeight = this.getRemainingHeight()
      const contentHeight = preCheckedHeight + this.SPACE_BETWEEN_CONTENT;
      let flag = contentHeight > remainingHeight;

      if(this.attemptToAddContent > 1) {
        throw new Error("Code: LARGE_CONTENT_DETECTED,  Error occurred while creating PDF")
      }

      if(flag){
        this.attemptToAddContent++;
        this.addPage();
        // We need to reload the coordinate  cause the x and y might change due to new  page added;
        return this.addContent(type, d);
      }
      if(ContentAdder[type]!){
        console.log(`Adding ${type} to page x:${preCheckedX}, y:${preCheckedY}`);
        let h = ContentAdder[type].bind(this)(d, preCheckedX, preCheckedY);
        let height = d.genericType == 'quantitative' ? preCheckedHeight : h;
        //Reload the nextYCoord cause that might changed now
        this.nextYCoord =  this.nextYCoord + this.SPACE_BETWEEN_CONTENT + height;
        this.occupiedPageSpace +=  this.SPACE_BETWEEN_CONTENT + height;
        this.attemptToAddContent = 0;
      }  
    }
  
    render() {
      let counter= 0;
      while(this.data.length != counter) {
        let data:any = this.data[counter];
        this.addContent(data.type, data);
        counter++;
      }
     
    }
  
    save(name?:string | null){
      let cleanedFileName = "download.pdf";
      if(name){
        cleanedFileName = this.cleanFileName(name);
      }
     
      this.render();
      this.doc.save(cleanedFileName);
      return cleanedFileName;
    }

    cleanFileName(name:string) {
      return `${name.replace(" ", "-").toLowerCase()}.pdf`
    }
  }
  